import { Box, Grid } from '@chakra-ui/react';
import { InputField } from '../../../inputs/InputField/inputField';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { TwoColumn } from '../../containers/TwoColumn/twoColumn';
import { LeftColumn } from '../../containers/TwoColumn/leftColumn';
import { RightColumn } from '../../containers/TwoColumn/rightColumn';
import { FormSectionHeading } from 'src/components/common/texts/FormSectionHeading/formSectionHeading';
import { FormSectionAddon } from 'src/components/common/texts/FormSectionAddon/formSectionAddon';


export const SetSupply  = () => {
	const { values } = useFormikContext();
	const { t } = useTranslation();

	return (
		<TwoColumn>
			<LeftColumn>
				<FormSectionHeading label={t('form.steps.setSupply.label')}>{t('form.steps.setSupply.heading')}</FormSectionHeading>
				<Grid
					templateColumns="1fr 1fr"
					gridGap="20px"
					w="100%"
				>
					<InputField
						label={t('form.fields.totalSupply')}
						name="totalSupply"
						placeholder="Price"
					/>
					<InputField
						label={t('form.fields.storeSupply')}
						name="storeSupply"
						placeholder="Price"
					/>
				</Grid>
				<FormSectionAddon>
					<Box>{t('form.headers.metadata.description')}</Box>
				</FormSectionAddon>
			</LeftColumn>
			<RightColumn>
				
			</RightColumn>
		</TwoColumn>
	);
};
